// @flow
import React, { Component } from "react";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

import { LoadingProgress } from "imagus-components";
import QuoteTableRow from "./QuoteTableRow";

type QuoteTablePropsType = {
  table: Array<Array<*>>,
  authorised_reseller: boolean,
  totalRow: Array<*>,
  licence_type: string,
  create_date?: Date,
  tier_name?: string | null,
  companyType: string,
  productSheetName?: string | null
};

class QuoteTable extends Component<QuoteTablePropsType, *> {
  render(): * {
    let table = this.props.table;
    let totalRow = this.props.totalRow;

    const authorised_reseller = this.props.authorised_reseller;
    const isShortTerm = this.props.licence_type === "SHORTTERM";
    const isReseller = this.props.companyType === "RESELLER";

    if (table === undefined) {
      return (
        <div className="app-panel-content panel-top-margin">
          <LoadingProgress />
        </div>
      );
    } else {
      if (isReseller) {
        totalRow.splice(4, 1);
        table.map((row: Array<*>) => {
          row.splice(4, 1);
        });
      }
      const list = table.map(
        (row: Array<*>, i: number): * => <QuoteTableRow key={i} row={row} />
      );
      return (
        <Paper style={{ padding: "10px 0" }}>
          <div style={{ height: "100%" }}>
            <Typography variant="h5" className="form-text">
              PRODUCT PRICE LIST - Imagus Pricing Schedule For{" "}
              {authorised_reseller ? "Authorised" : "Standard"} Resellers ONLY
            </Typography>
            <Typography variant="subtitle1" className="form-text form-hint">
              *All pricing excludes GST and this Price List must be distributed
              by the terms and conditions of your Distributor Agreement and NDA.
            </Typography>
            <Typography
              variant="subtitle1"
              className="form-text form-hint bottom-margin-15"
            >
              *This quote is generated on{" "}
              {moment
                .utc(this.props.create_date)
                .local()
                .format("DD/MMM/YYYY")}
              , all prices would only valid for <b>30</b> days.
            </Typography>
          </div>
          <Table className="app-table green center">
            <TableHead>
              <TableRow className="active">
                <TableCell className="blue-shine" width="140">
                  Part No.
                </TableCell>
                <TableCell className="blue-shine">Description</TableCell>
                <TableCell className="blue-shine">Qty</TableCell>
                <TableCell className="blue-shine">Retail Price(AUD)</TableCell>
                {!isReseller && (
                  <TableCell className="blue-shine">
                    Distributor Price(AUD)
                  </TableCell>
                )}
                <TableCell className="blue-shine">
                  Reseller Price(AUD)
                </TableCell>
                <TableCell className="blue-shine">Notes</TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  colSpan={isReseller ? 6 : 7}
                  style={{
                    fontSize: "1rem",
                    fontWeight: "600",
                    lineHeight: "24px"
                  }}
                >
                  {authorised_reseller ? (
                    <span>
                      {"Imagus Authorised " +
                        (isShortTerm ? " Short Term " : "") +
                        "Pricing"}
                    </span>
                  ) : (
                    <span>
                      {"Imagus Standard " +
                        (isShortTerm ? " Short Term " : "") +
                        "Pricing"}
                    </span>
                  )}
                  {!isShortTerm && (
                    <span className="green-label left-margin-5">
                      (with 1 year maintenance)
                    </span>
                  )}
                  {this.props.tier_name && (
                    <span
                      style={{ fontStyle: "italic" }}
                      className="left-margin-5"
                    >
                      ({this.props.tier_name})
                    </span>
                  )}
                  {this.props.productSheetName && (
                    <span
                      style={{ fontStyle: "italic" }}
                      className="left-margin-5"
                    >
                      ({this.props.productSheetName})
                    </span>
                  )}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {list}
              <QuoteTableRow row={totalRow} isBorder />
            </TableBody>
          </Table>
        </Paper>
      );
    }
  }
}

export default QuoteTable;
